module.exports = __webpack_public_path__ + "img/logo-mark.c5941dda.svg";